import React from 'react';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import './ImpressumPage.css';

const ImpressumPage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="impressum-page">
            <div className="impressum-container">
                <header className="impressum-header">
                    <h1>{t('impressum.title')}</h1>
                </header>

                <section className="impressum-section">
                    <h2>{t('impressum.legalNotice')}</h2>
                    <p><em>{t('impressum.testPhase')}</em></p>
                    <address className="impressum-address">
                        Nicole Osmenda<br />
                        Altenberger Gasse 9<br />
                        53639 Konigswinter<br />
                        Deutschland
                    </address>
                </section>

                <section className="impressum-section">
                    <h2>{t('impressum.contact')}</h2>
                    <p>
                        {t('impressum.phone')}: +49 163 1939982<br />
                        {t('impressum.email')}: <a href="mailto:nicole@hofsync.com">nicole@hofsync.com</a>
                    </p>
                </section>

                <section className="impressum-section">
                    <h2>{t('impressum.responsible')}</h2>
                    <address className="impressum-address">
                        Nicole Osmenda<br />
                        Altenberger Gasse 9<br />
                        53639 Konigswinter
                    </address>
                </section>

                <section className="impressum-section">
                    <h2>{t('impressum.disclaimer')}</h2>
                    <p>{t('impressum.disclaimerText')}</p>
                </section>

                <div className="impressum-back">
                    <Link to="/" className="impressum-back-link">
                        {t('impressum.backToHome')}
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ImpressumPage;
